import { render } from "./add-contact-to-group.vue?vue&type=template&id=75fae596"
import script from "./add-contact-to-group.vue?vue&type=script&lang=js"
export * from "./add-contact-to-group.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__